import { render, staticRenderFns } from "./IndependantFormNew.vue?vue&type=template&id=6fa7ea96"
import script from "./IndependantFormNew.vue?vue&type=script&lang=js"
export * from "./IndependantFormNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports